import React, { memo } from 'react';
import { createUseStyle } from '@redlink/assets/styles';
import { IconButton } from '@redlink/components/atoms';

export const FloatIconButton = memo(({ onPress, children }) => {
  const { styles } = useStyle();
  return (
    <IconButton style={styles.listTypeButton} {...{ onPress }}>
      {children}
    </IconButton>
  );
});

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  listTypeButton: {
    position: 'absolute',
    left: 24,
    bottom: 30,
    backgroundColor: colors.primary,
    width: 56,
    height: 56,
    ...shadow.card,
  },
}));
